import * as React from "react";
const DropdownListSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.5 3h-9C3.67 3 3 3.67 3 4.5v2C3 7.33 3.67 8 4.5 8h9c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5Zm.5 3.5c0 .28-.22.5-.5.5h-9c-.28 0-.5-.22-.5-.5v-2c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v2ZM6 10h6v1H6v-1Zm0 3h6v1H6v-1Z" }));
DropdownListSmall.displayName = "DropdownListSmall";
var DropdownListSmall_default = DropdownListSmall;
export {
  DropdownListSmall_default as default
};
